<template>
    <responsive-button
        @click="exportToExcel"
        :icon="['fas', 'file-excel']"
        :responsiveness="responsiveness"
        :busy="busy"
        :disabled="disabled"
        :variant="variant"
        ><span v-if="displayLabel">{{ label }}</span
    ></responsive-button>
</template>

<script>
import { saveAs } from 'file-saver';
import API from '../../../api';
import ResponsiveButton from '../responsive-button/responsive-button.vue';

export default {
    components: { ResponsiveButton },
    props: {
        href: String,
        onTooManyRecords: {
            type: Function,
            default: null,
        },
        responsiveness: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        displayLabel: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'Export to Excel',
        },
        variant: {
            type: String,
            default: 'primary'
        }
    },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        async exportToExcel() {
            this.generatingExcelReportSuccessToast();

            this.busy = true;
            this.$emit('busy', true);
            try {
                const response = await API.get(this.href, { responseType: 'blob' });
                saveAs(response.data, this.getFilenameFromResponse(response));
            } catch (err) {
                const text = (!!err.response && !!err.response.data)
                    ? await err.response.data.text()
                    : null;
                if (text && text.includes('Too many records')) {
                    if (this.onTooManyRecords) {
                        this.onTooManyRecords();
                    } else {
                        this.errorToast({ text: "Couldn't generate Excel because of too many records." });
                    }
                } else {
                    this.errorToast({ text: "Couldn't download Excel." });
                }
            } finally {
                this.busy = false;
                this.$emit('busy', false);
            }
        },
        getFilenameFromResponse(response) {
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                return /filename="(?<filename>.*)"/.exec(contentDisposition)?.groups?.filename;
            }
        }
    }
};
</script>
